export enum GridAggFunction {
	SUM_OF_CURRENCY = "sumOfCurrency",
}
